<template>
  <div>
        <el-row :gutter="24">

      <el-col :span="4">
        <el-input placeholder="手机号" v-model="params.mobile" size="mini"><el-button slot="append" icon="el-icon-search" @click="getSearch"></el-button></el-input>
      </el-col>
    </el-row>
    <el-table :data="cardList" style="width: 100%" border height="600" v-loading="loading">
      <el-table-column prop="username" label="用户名字"></el-table-column>
      <el-table-column prop="title" label="卡券名称"></el-table-column>
      <el-table-column prop="mobile" label="手机号"></el-table-column>
      <el-table-column label="领取时间">
        <template slot-scope="scope">
          <span v-if="'0' != scope.row.get_date">{{scope.row.get_date|datetime('yyyy-MM-dd hh:mm:ss')}}</span>
          <span v-else>老数据</span>
        </template>
      </el-table-column>
      <el-table-column prop="source_type" label="来源类型"></el-table-column>
      <el-table-column label="是否使用">
        <template slot-scope="scope">
          <span>
            <el-tag size="mini" type="success" v-if="scope.row.status == '1'">未使用</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.status != '1'">已使用</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column  label="过期时间">
        <template slot-scope="scope">
          <span>
            {{scope.row.end_date|datetime('yyyy-MM-dd hh:mm:ss')}}
          </span>
        </template>
      </el-table-column>
        <el-table-column  label="操作">
           <template slot-scope="scope">
              <el-tag @click="del(scope.row,index)">删除</el-tag>
        </template>
        </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page.sync="params.page"
      :page-sizes="[10,20,50]"
      :total="total_count"
      :page-size="params.pageSize">
    </el-pagination>
  </div>
</template>

<script>
import {getCardUserList,delUserCard} from '../../../../api/cardticket'

export default {
  props: ['getStatus'],
  data() {
    return {
      loading: false,
      total_count: 0,
      cardList: [],
      params: {
        card_id: 0,
        page: 1,
        pageSize: 20,
        mobile:'',
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.params.page = val
      this.getCardUserList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getCardUserList()
    },
    getSearch(){
      this.params.page = 1
      this.getCardUserList()
    },
    del(row,index){
       this.$confirm('确定要删除['+row.username+']-['+row.title+']卡券？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            delUserCard({id:row.id,user_id:row.user_id}).then(res=>{

              if(res.data.data.status == 1){
                this.cardList.splice(index, 1)
                   this.$message({
                    message: '删除成功!',
                    type: 'success',
                    duration: 2 * 1000
                  })
              }else{
                  this.$message({
                    message: '删除失败!',
                    type: 'error',
                    duration: 2 * 1000
                  })
              }

            })
          }
        done()
        }
      })

    },
    getCardUserList() {
      this.loading = true
      getCardUserList(this.params).then(res => {
        if (res.data.data.list.length > 0) {
          this.cardList = res.data.data.list
          this.total_count = res.data.data.count
          this.loading = false
        } else {
          this.cardList = []
          this.loading = false
        }
      })
      .catch(error => {
        this.loading = false
      })
    }
  },
  watch: {
    getStatus(val) {
      if (val) {
        this.getCardUserList()
      }
    }
  },
  mounted() {
    if (this.$route.query.cardId) {
      this.params.card_id = this.$route.query.cardId
    }
    this.getCardUserList()
  }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// receive.vue?0665d242